(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7898"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7898"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $mjRaB = parcelRequire("mjRaB");

var $a0v8t = parcelRequire("a0v8t");

var $gzKpA = parcelRequire("gzKpA");

var $jwBDG = parcelRequire("jwBDG");
let $369d0306fe189709$var$startTimestamp = null;
let $369d0306fe189709$var$endTimestamp = null;
const $369d0306fe189709$var$setEndTimestamp = (timestamp)=>{
    $369d0306fe189709$var$endTimestamp = timestamp;
    document.getElementById("timer-results").setAttribute("data-time", "" + ($369d0306fe189709$var$endTimestamp - $369d0306fe189709$var$startTimestamp));
};
(0, $jwBDG.onReset)(()=>{
    $369d0306fe189709$var$startTimestamp = null;
    $369d0306fe189709$var$endTimestamp = null;
    document.getElementById("timer-results").removeAttribute("data-time");
});
const $369d0306fe189709$var$handleInputInteraction = (event)=>{
    if ($369d0306fe189709$var$startTimestamp === null) $369d0306fe189709$var$startTimestamp = event.timeStamp;
};
window.addEventListener((0, $mjRaB.DATE_CHANGE_EVENT_NAME), (event)=>{
    const date = event.detail;
    if ($369d0306fe189709$var$endTimestamp === null && (0, $a0v8t.checkDate)(date)) $369d0306fe189709$var$setEndTimestamp(event.timeStamp);
});
(0, $gzKpA.onInit)(()=>{
    const input = document.querySelectorAll("input, select");
    const events = [
        "focus",
        "blur",
        "change",
        "input"
    ];
    for (const el of Array.from(input))for (const event of events)el.addEventListener(event, $369d0306fe189709$var$handleInputInteraction);
});

})();
//# sourceMappingURL=index.26ff342a.js.map
